<template>
  <section class="section section-shaped section-lg my-0">
    <base-alert
      v-if="alertShow"
      type="danger"
      dismissible
      style="max-width: 1080px; margin: 0 auto"
      >验证码已发送到您的电子邮件，请注意查收。
      <strong>也许在垃圾邮件文件夹中</strong>
    </base-alert>
    <div class="shape shape-style-1 bg-gradient-default">
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-muted text-center mb-3">
                <small>用户 注册</small>
              </div>
            </template>
            <template>
              <form role="form" @keyup.enter="handleSubmit">
                <base-input
                  v-model.trim="form.email"
                  :error="emailerr"
                  alternative
                  class="mb-3"
                  placeholder="登陆邮箱"
                  addon-left-icon="ni ni-email-83"
                />
                <div class="pr">
                  <base-input
                    v-model="form.code"
                    :error="codeerr"
                    alternative
                    class="mb-3"
                    placeholder="邮箱验证码"
                    addon-left-icon="ni ni-email-83"
                  />

                  <base-button
                    :disabled="loading"
                    type="primary"
                    size="sm"
                    class="code-btn"
                    @click.stop.prevent="getCode"
                  >
                    <div v-if="count === TIME_COUNT">
                      <span
                        v-if="loading"
                        aria-hidden="true"
                        class="spinner-grow spinner-grow-sm"
                      />
                      <span>获取验证码</span>
                    </div>

                    <span v-else style="min-width: 4rem; display: inline-block">
                      {{ count >= 10 ? count : `0${count}` }} 秒
                    </span>
                  </base-button>
                </div>

                <base-input
                  :error="passerr"
                  v-model="form.password"
                  alternative
                  type="password"
                  placeholder="登陆密码"
                  addon-left-icon="ni ni-lock-circle-open"
                />
                <base-input
                  :error="repasserr"
                  v-model="form.re_password"
                  alternative
                  type="password"
                  placeholder="确认登陆密码"
                  addon-left-icon="ni ni-lock-circle-open"
                />
                <!-- <base-checkbox>
                                    Remember me
                                </base-checkbox> -->

                <div class="text-center">
                  <base-button
                    :disabled="regLoad"
                    type="primary"
                    class="my-4"
                    @click="handleSubmit"
                  >
                    <span
                      v-if="regLoad"
                      aria-hidden="true"
                      class="spinner-grow spinner-grow-sm"
                    />
                    确认 注册
                  </base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <router-link class="text-light" to="/login">
                <small>用户登录</small>
              </router-link>
            </div>
            <div class="col-6 text-right">
              <router-link class="text-light" to="/recover">
                <small>忘记密码？</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import { sendCode, signup } from '@/api/user'
const TIME_COUNT = 60
export default {
  name: 'LoginForm',
  data() {
    return {
      TIME_COUNT,
      count: TIME_COUNT,
      timer: null,
      loading: false,
      regLoad: false,
      alertShow: false,
      form: {
        email: '',
        password: '',
      },
      passerr: '',
      emailerr: '',
      codeerr: '',
      repasserr: '',
    }
  },
  watch: {
    'form.email': function (value) {
      const pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      this.emailerr = ''
      if (!pattern.test(value)) {
        this.emailerr = '登陆邮箱格式有误，请核对！'
      } else {
        this.emailerr = ''
      }
    },
  },
  methods: {
    ...mapActions(['handleLogin', 'getUserInfo']),
    async handleSubmit() {
      let { email, password, re_password, code } = this.form
      email = email.toLowerCase()
      const pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      this.emailerr = ''
      this.passerr = ''
      if (!pattern.test(email)) {
        this.emailerr = '登陆邮箱格式有误，请核对！'
        return
      }
      if (!password) {
        this.passerr = '登陆密码不能为空，请核对！'
        return
      }
      if (password !== re_password) {
        this.passerr = '两次密码不一样，请核对！'
        return
      }
      this.regLoad = true
      try {
        await signup(this.form)
        await this.handleLogin({ email, password })
        await this.getUserInfo()
        this.$router.push({
          name: this.$config.homeName,
        })
        this.regLoad = false
      } catch (err) {
        this.regLoad = false
        console.log(err)
      }
    },
    async getCode() {
      let { email } = this.form
      email = email.toLowerCase()
      const pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      this.emailerr = ''
      if (!pattern.test(email)) {
        this.emailerr = '登陆邮箱格式有误，请核对！'
        return
      }
      this.loading = true
      try {
        const params = {
          email,
          type: 'signup',
        }
        await sendCode(params)
        this.count--
        this.alertShow = true
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            clearInterval(this.timer)
            this.timer = null
            this.count = TIME_COUNT
            this.loading = false
          }
        }, 1000)
      } catch (err) {
        this.loading = false
        console.log(err)
      }
    },
  },
}
</script>
<style>
.pr {
  position: relative;
}
.code-btn {
  position: absolute;
  z-index: 10;
  top: 0.6rem;
  right: 1rem;
}
</style>
